import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { FormModalBaseComponent } from 'src/app/core/base/components/form-modal-base/form-modal-base.component';
import { AnnualChargeModel } from 'src/app/core/models/annual-charge.model';
import { CrudModeEnum } from 'src/app/core/base/enum/crud-mode.enum';

@Component({
  selector: 'vex-establishment-annual-charge-create-update',
  templateUrl: './establishment-annual-charge-create-update.component.html',
})
export class EstablishmentAnnualChargeCreateUpdateComponent implements OnInit {
  form: UntypedFormGroup;
  mode: CrudModeEnum;
  defaults: AnnualChargeModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FormModalBaseComponent<AnnualChargeModel>>,
  ) {}

  ngOnInit() {
    this.mode = this.data.mode;
    this.defaults = this.data.defaults;
    this.form = new UntypedFormGroup({
      year: new UntypedFormControl(this.defaults?.year, [
        Validators.required,
        this.yearValidator,
      ]),
      amount: new UntypedFormControl(this.defaults?.amount, [Validators.required]),
    });
  }

  yearValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;
    return value >= 1000 && value <= 9999 ? null : { customError: true };
  }

  save() {
    if (this.form.valid) {
      const charge: AnnualChargeModel = this.form.getRawValue();
      if (this.mode === CrudModeEnum.Update) {
        charge.previousYear = this.defaults.year;
      }
      this.close(charge);
    }
  }

  close(res?: any) {
    this.dialogRef.close(res);
  }
}
